/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tooltip_Internalnamespace2Inputs */

const id_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace internal Epic Games`)
};

const ms_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace dalaman Epic Games`)
};

const da_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games internt namespace`)
};

const de_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games interner Namespace`)
};

const en_us2_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games internal namespace`)
};

const es_es2_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno de Epic Games`)
};

const es_mx2_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno de Epic Games`)
};

const fil_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal na namespace ng Epic Games`)
};

const fr_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interne d'Epic Games`)
};

const it_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno Epic Games`)
};

const hu_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games belső namespace`)
};

const nl_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne namespace van Epic Games`)
};

const no_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games intern namespace`)
};

const pl_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewnętrzny namespace Epic Games`)
};

const pt_br2_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno da Epic Games`)
};

const pt_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno da Epic Games`)
};

const ro_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace intern Epic Games`)
};

const fi_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Gamesin sisäinen namespace`)
};

const sv_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internt namespace för Epic Games`)
};

const vi_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace nội bộ của Epic Games`)
};

const tr_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games dahili ad alanı`)
};

const cs_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interní namespace Epic Games`)
};

const bg_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вътрешно Namespace на Epic Games`)
};

const ru_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутреннее пространство имён (namespace) Epic Games`)
};

const uk_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутрішній Namespace Epic Games`)
};

const ar_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace داخلي لـ Epic Games`)
};

const hi_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games आंतरिक नेमस्पेस`)
};

const th_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace ภายในของ Epic Games`)
};

const ja_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 内部 Namespace`)
};

const zh_cn2_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏内部命名空间`)
};

const zh_hant1_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲內部命名空間`)
};

const ko_offerdetail_tooltip_internalnamespace2 = /** @type {(inputs: Offerdetail_Tooltip_Internalnamespace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 내부 Namespace`)
};

/**
* | output |
* | --- |
* | "Epic Games internal namespace" |
*
* @param {Offerdetail_Tooltip_Internalnamespace2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tooltip_internalnamespace2 = /** @type {((inputs?: Offerdetail_Tooltip_Internalnamespace2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tooltip_Internalnamespace2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "ms") return ms_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "da") return da_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "de") return de_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "fil") return fil_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "fr") return fr_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "it") return it_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "hu") return hu_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "nl") return nl_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "no") return no_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "pl") return pl_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "pt") return pt_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "ro") return ro_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "fi") return fi_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "sv") return sv_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "vi") return vi_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "tr") return tr_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "cs") return cs_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "bg") return bg_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "ru") return ru_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "uk") return uk_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "ar") return ar_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "hi") return hi_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "th") return th_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "ja") return ja_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tooltip_internalnamespace2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tooltip_internalnamespace2(inputs)
	return ko_offerdetail_tooltip_internalnamespace2(inputs)
});
export { offerdetail_tooltip_internalnamespace2 as "offerDetail.tooltip.internalNamespace" }